<template>
    <div>
        <b-row>
            <b-col>
                <h5 class="text-secondary">Integrations</h5>
            </b-col>

            <b-col align="right">
                <b-dropdown size="sm" variant="outline-secondary" toggle-class="text-decoration-none" no-caret>
                    <template #button-content>
                        <b-icon-caret-down></b-icon-caret-down>
                    </template>

                    <b-dropdown-item @click="addIntegration(platform.value)" v-for="platform in integrationPlatforms" :key="platform.value">
                        {{ platform.text }}
                    </b-dropdown-item>

                </b-dropdown>
            </b-col>
        </b-row>

        <b-row v-if="!sortedIntegrations.length">
            <b-col align="center">
                <!--<drop @drop="dropPressing($event)" style="width: 100%">-->
                    <b-list-group>
                        <b-list-group-item variant="light">
                            <small><em>No Integrations</em></small>
                        </b-list-group-item>
                    </b-list-group>
                <!--</drop>-->
            </b-col>
        </b-row>

        <div v-for="(integration, index) in sortedIntegrations" v-bind:key="integration.platform || index">
            <!--<drop @drop="dropPressing($event)" style="width: 100%">-->
                <b-input-group size="sm">
                    <b-form-select :options="integrationPlatforms"
                                   v-model="integration.platform"
                                   @change="changePlatform(integration.platform, integration)"
                                   :state="integration.platform && integration.platform.length ? null : false"
                                   disabled>
                        <template #first>
                            <b-form-select-option :value="undefined" disabled>Platform</b-form-select-option>
                        </template>
                    </b-form-select>

                    <b-input
                             style="width: 5rem;"
                             :ref="'releaseId-' + (integration.platform || index)"
                             v-model="integration.releaseId"
                             placeholder="Release ID"
                             :state="integration.releaseId && integration.releaseId.length ? null : false"
                             >
                    </b-input>

                    <b-input-group-append v-if="integration.releaseId && integration.releaseId.length">
                        <b-button size="sm" variant="outline-primary" @click="viewIntegration(integration)" tabindex="-1">
                            <b-icon-box-arrow-up-right></b-icon-box-arrow-up-right>
                        </b-button>
                    </b-input-group-append>

                    <b-input-group-append>
                        <b-button size="sm" variant="outline-secondary" @click="removeIntegration(integration)" tabindex="-1">
                            <b-icon-x></b-icon-x>
                        </b-button>
                    </b-input-group-append>
                </b-input-group>
            <!--</drop>-->
        </div>
    </div>
</template>

<script>
    import arrayMixin from "../../mixins/array";
    import integrationPlatformOptions from "../../assets/integrationPlatformOptions";

    export default {
        name: "Integration",
        props: [ 'integrations' ],
        mixins: [ arrayMixin, integrationPlatformOptions ],
        created() {
            if (this.integrations.length < this.integrationPlatforms.length) {
                this.integrationPlatforms.forEach(platform => {
                    if (!this.integrations.find(i => i.platform === platform.value)) {
                        this.integrations.push({platform: platform.value});
                    }
                });
            }
            
            this.clone(this.integrations);
            // Sort integrations after cloning to ensure correct order
            this.$nextTick(() => {
                this.sortIntegrations();
            });

        },
        mounted() {
            this.originalIntegrations = [...this.integrations];
        },
        data() {
            return {
                originalIntegrations: {},
            }
        },
        methods: {
            changePlatform(platform, integration) {
                if (platform) {
                    this.$nextTick(() => {
                        let refKey = 'releaseId-' + (integration.platform || this.component.indexOf(integration));
                        let ref = this.$refs[refKey];
                        if (ref && ref[0]) {
                            ref[0].$el.focus();
                        }
                    });
                }
            },
            addIntegration(platform) {
                this.component.push({ platform: platform, releaseId: null, username: this.$auth.user.nickname, date: new Date().toISOString()});
                // Re-sort after adding to maintain order
                this.sortIntegrations();
            },
            sortIntegrations() {
                // Sort the component array in place according to integrationPlatforms order
                this.component.sort((a, b) => {
                    const indexA = this.integrationPlatforms.findIndex(p => p.value === a.platform);
                    const indexB = this.integrationPlatforms.findIndex(p => p.value === b.platform);
                    
                    // If platform not found, put it at the end
                    if (indexA === -1) return 1;
                    if (indexB === -1) return -1;
                    
                    return indexA - indexB;
                });
            },
            removeIntegration(integration) {
                const index = this.component.indexOf(integration);
                if (index > -1) {
                    this.component.splice(index, 1);
                }
            },
            dropPressing(note) {
                let type = null;

                if (note === '(Mono)') {
                    type = 'fidelity';
                }

                this.component.push({ text: note, type: type });
                this.handleNoteDrop(note);
            },
            handleNoteDrop(note) {
                this.$emit('dropNote', note);
            },
            viewIntegration(integration) {
                if (integration.platform === 'discogs') {
                    let url = process.env.VUE_APP_DISCOGS_RELEASE_URL + integration.releaseId;

                    window.open(url, integration.platform);
                } else if (integration.platform === 'amazon') {
                    let url = process.env.VUE_APP_AMAZON_RELEASE_URL + integration.releaseId;

                    window.open(url, integration.platform);
                } else if (integration.platform === 'amazon-uk') {
                    let url = process.env.VUE_APP_AMAZON_UK_RELEASE_URL + integration.releaseId;

                    window.open(url, integration.platform);
                }
            },
        },
        computed: {
            hasGenre() {
                for (let i = 0; i < this.component.length; i++) {
                    if (!this.component[i].type) {
                        return true;
                    }
                }

                return false;
            },
            sortedIntegrations() {
                // Sort integrations according to the order defined in integrationPlatforms
                return [...this.component].sort((a, b) => {
                    const indexA = this.integrationPlatforms.findIndex(p => p.value === a.platform);
                    const indexB = this.integrationPlatforms.findIndex(p => p.value === b.platform);
                    
                    // If platform not found, put it at the end
                    if (indexA === -1) return 1;
                    if (indexB === -1) return -1;
                    
                    return indexA - indexB;
                });
            },
        }
    }
</script>

<style scoped>
</style>